import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsIC: CultureInfo = {
  name: 'es-IC',
  displayName: 'español (Canarias)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-IC',
  parent: CultureInfoEs
};
